import { Button } from '@microservices/wiskey-react-components'

import { buttonStylesByMode } from '@helpers'

interface ConfiguredEntityEditButtonProps {
  isViewDialogWindow: boolean
  onEdit: () => void
}

export const ConfiguredEntityEditButton: React.FC<ConfiguredEntityEditButtonProps> = props => {
  const { isViewDialogWindow, onEdit: handleEdit } = props

  return (
    <Button
      variant='outlined'
      sx={theme => ({
        ...buttonStylesByMode(theme, isViewDialogWindow),
        zIndex: 2,
        mr: 1.5,
      })}
      onClick={handleEdit}
    >
      Edit
    </Button>
  )
}

ConfiguredEntityEditButton.displayName = 'ConfiguredEntityEditButton'
